var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.filteredTasks.length)?_c('div',{staticClass:"task-field"},[_c('p',{staticClass:"task-field__title"},[_vm._v("Задачи планирования:")]),_vm._v(" "),_vm._l((_vm.filteredTasks),function(task){return _c('p',{key:task.id},[_vm._v("- "+_vm._s(task.name))])})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/public/forms/fields/TaskField.vue?vue&type=template&id=c407369e&
// module id = 1142
// module chunks = 0